module.exports = __webpack_public_path__ + "static/media/mh.b656bda1.svg";